import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Security } from '../../icons';
import { EVENT_FAQ_CONST, EVENT_FAQ_ANSWERS_CONST } from '../data/constants';
import { eventFaqDefinition, miscEventFaqDefinitions, category_labels } from '../data/eventFaqDefinition';
import { getFormattedTime } from '../../search-module/components/date-time/mobile/helpers/helpers';

const EventRulesExpanded = ({ faqData = {}, hasValidEndTime, hasFlexibleHours, intl }) => {
  const { HOURS_ADJUSTED_UPON_REQUEST, HAS_NO_FLEXIBLE_HOURS } = EVENT_FAQ_ANSWERS_CONST;
  const { HAS_FLEXIBLE_HOURS } = EVENT_FAQ_CONST;
  const label = <FormattedMessage
    id={category_labels.rules.id}
    defaultMessage={category_labels.rules.defaultMessage}
  />;
  return (
    <div className="EventFAQ">
      <div className="flex middle">
        <Security height={24} width={24} className="margin-sm-right" />
        <div className="h6 margin-md-left padding-xs-top padding-xs-bottom faq-section">{label}</div>
      </div>
      <div className="event-faq-section padding-md-bottom">
        {
          hasValidEndTime &&
              <div className="margin-lg-bottom section-indent">
                <div>
                  <div className="faq-label heavier margin-lg-bottom">
                    {intl.formatMessage(miscEventFaqDefinitions.quiet_hours_header)}
                  </div>
                  <div className="faq-label margin-lg-bottom">
                    {intl.formatMessage(eventFaqDefinition.event_rules.loud_music_ends_by)}
                    &nbsp;
                    {getFormattedTime(faqData.loud_music_ends_by, intl)}
                  </div>
                </div>
                {hasFlexibleHours && <hr />}
              </div>
        }
        {
          hasFlexibleHours &&
              <div className="margin-lg-bottom section-indent">
                <div>
                  <div className="faq-label heavier margin-lg-bottom">
                    {intl.formatMessage(miscEventFaqDefinitions.flexible_hours)}
                  </div>
                  <div className="faq-label margin-lg-bottom">
                    {
                      HOURS_ADJUSTED_UPON_REQUEST === faqData[HAS_FLEXIBLE_HOURS]
                        ? intl.formatMessage(eventFaqDefinition.event_rules[HAS_FLEXIBLE_HOURS][HOURS_ADJUSTED_UPON_REQUEST])
                        : intl.formatMessage(eventFaqDefinition.event_rules[HAS_FLEXIBLE_HOURS][HAS_NO_FLEXIBLE_HOURS])
                    }
                  </div>
                </div>
              </div>
        }
      </div>
    </div>
  );
};

EventRulesExpanded.propTypes = {
  faqData: PropTypes.object,
  hasValidEndTime: PropTypes.bool,
  hasFlexibleHours: PropTypes.bool,
  intl: PropTypes.object
};

export default injectIntl(EventRulesExpanded);
